import { APICore } from './apiCore'

const api = new APICore()

function getConfSurvey (owner, destination) {
  let baseUrl = `/conf-survey/${owner}`
  if (destination) {
    baseUrl += `/${destination}`
  }
  return api.get(baseUrl, {})
}

function updateConfSurvey (params) {
  const baseUrl = '/conf-survey'
  return api.update(baseUrl, params)
}

export { getConfSurvey, updateConfSurvey }
